'use client';

import SafeImage from '@ui/SafeImage';
import { prefix } from '@util/imagePrefix';
import { cn } from '@util/index';
import { AppStoreButtons } from 'app/get-the-app/components/GetTheApp';
import FreeEntryModal from 'app/adolf-silva-giveaway/components/FreeEntryModal';
import { ArrowRightIcon } from 'lucide-react';
import { Roboto } from 'next/font/google';
import { useState } from 'react';

const roboto = Roboto({
  subsets: ['latin'],
});

type NewToMXProps = {
  showFreeEntryPrompt?: boolean;
};

export default function NewToMX({ showFreeEntryPrompt = true }: NewToMXProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full bg-black">
      {showFreeEntryPrompt && (
        <button
          type="button"
          className="w-full border-b border-zinc-800 py-[3rem]"
          onClick={() => setIsOpen(true)}
        >
          <div className="flex justify-between px-16 sm:mx-auto sm:max-w-content sm:px-0">
            <span className="text-[2rem] font-bold text-white">
              WANT A FREE ENTRY? ENTER HERE
            </span>

            <ArrowRightIcon className="size-12 text-white" />
          </div>
        </button>
      )}

      <div className="flex flex-col items-center px-16 pt-[5rem] sm:flex-row sm:justify-between sm:gap-32 sm:px-0 sm:mx-auto sm:max-w-[140rem]">
        <SafeImage
          src={`${prefix}/assets/new-app_1920x2560.png`}
          alt="New MX Locker App"
          className="h-[40rem] w-auto sm:h-[60rem]"
          width={1920}
          height={2560}
        />

        <div className="flex flex-col items-start gap-4 pb-16 pt-8 sm:pb-0 sm:pt-0">
          <span
            className={cn(
              roboto.className,
              'text-[4rem] font-bold uppercase tracking-tight text-white sm:text-[6rem]'
            )}
          >
            New to MXLocker?
          </span>

          <p className="text-[1.8rem] font-medium text-[#D9D9D9] sm:text-[2rem]">
            MX Locker is a peer to peer marketplace built for the powersports
            community. We connect riders across the world to shop and sell
            almost anything. Our mission is to make powersports more affordable
            and accessible to our community!
          </p>

          <AppStoreButtons center={false} />
        </div>
      </div>

      {showFreeEntryPrompt && (
        <FreeEntryModal isOpen={isOpen} dismiss={() => setIsOpen(false)} />
      )}
    </div>
  );
}
